import './BayList.scss';
import PropTypes from 'prop-types';
// import Error from '../../common/Error/Error';

// BayList Component
const BayList = ({ handleClick, bays, racks }) => {
  return (
    <div className="bay_list_container">
      <div className="bays_grid">
        <div className="bay_button" onClick={() => handleClick('none')}>
          Unassigned
        </div>
      </div>
      <div className="bays_grid">
        {bays?.map(bay => {
          return (
            <div className="bay_button" key={bay.id} onClick={() => handleClick(bay)}>
              {`${bay.bayType[0]}${bay.bayNumber}`.toUpperCase()}
            </div>
          );
        })}
      </div>
      <div className="racks_grid">
        {racks &&
          Object.keys(racks).map(key => {
            return (
              <div key={`rack_${racks[key][0].bayNumber}`} className="rack_container">
                <div className="rack_number">R{racks[key][0].bayNumber}</div>
                {racks[key]?.map((rackSuffix, i) => {
                  return (
                    <div
                      className={`rack_button ${racks[key].length == i + 1 && 'last'}`}
                      key={rackSuffix.id}
                      onClick={() => handleClick(rackSuffix)}
                    >
                      {rackSuffix.suffix}
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    </div>
  );
};

BayList.propTypes = {
  handleClick: PropTypes.func,
  bays: PropTypes.array,
  racks: PropTypes.object,
};

export default BayList;
